import {IAdvancedTextConfig} from '@gongxigames/framework/slot';
import {TextStyle} from 'pixi.js';
import {buyButtonStyle, buyPopUpNotEnoughRubyStyle, defaultStyle, defaultStyleForPick} from 'src/configs/Styles';

export const pickBonusTexts: IAdvancedTextConfig[] = [{
    id: 'popupIntroTXT_2',
    style: new TextStyle({...defaultStyleForPick, fontSize: 80}),
    maxWidth: 670,
    slot: ''
}, {
    id: 'popupIntroTXT_3',
    style: new TextStyle({...defaultStyleForPick, fontSize: 60}),
    maxWidth: 670,
    slot: ''
}, {
    id: 'pickBonusTXT_1',
    style: new TextStyle({...defaultStyleForPick, fontSize: 150}),
    maxWidth: 1400,
    slot: ''
}, {
    id: 'pickBonusTXT_2',
    style: new TextStyle({...defaultStyleForPick, fontSize: 70}),
    maxWidth: 290,
    slot: ''
}];
export const buyButtonTXT: IAdvancedTextConfig[] = [{
    id: 'buyButtonBuyTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 60}),
    maxWidth: 160,
    slot: 'text_1',
    position: {x: 0, y: 35}
}, {
    id: 'buyButtonPlayTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 60}),
    maxWidth: 160,
    slot: 'text_1',
    position: {x: 0, y: 35}
}, {
    id: 'buyButtonBonusTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 60}),
    maxWidth: 270,
    slot: 'text_2',
    position: {x: -1, y: -50}
}];
export const buyPopUpTXT: IAdvancedTextConfig[] = [{
    id: 'buyPopUpPlayAtTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 190}),
    maxWidth: 2000,
    slot: ''
    // position: {x: -1, y: -16},
}, {
    id: 'buyPopUpTotalBetTXT',
    style: new TextStyle({...defaultStyle, fontSize: 90}),
    slot: '',
    maxWidth: 850,
    position: {y: 90}
}, {
    id: 'buyPopUpNotEnoughRubyTXT',
    style: new TextStyle({...buyPopUpNotEnoughRubyStyle}),
    slot: '',
    // position: {x: -1, y: -16},
    maxWidth: 850
}, {
    id: 'buyButtonBuyTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 150}),
    slot: ''
    // position: {x: -1, y: -16},
}, {
    id: 'buyButtonPlayTXT',
    style: new TextStyle({...buyButtonStyle, fontSize: 150}),
    slot: ''
    // position: {x: -1, y: -16},
}];
